var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStroke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6465 0.320239C14.1178 0.747224 14.1178 1.4395 13.6465 1.86649L5.68095 9.08298C5.20964 9.50997 4.4455 9.50997 3.97419 9.08298L0.35348 5.80276C-0.117827 5.37577 -0.117827 4.68349 0.35348 4.25651C0.824787 3.82952 1.58893 3.82952 2.06023 4.25651L4.82757 6.76361L11.9398 0.320239C12.4111 -0.106746 13.1752 -0.106746 13.6465 0.320239Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStroke);
export default __webpack_public_path__ + "static/media/Icon_Stroke.ff03204f80ef96b3b048c3ab6917f4fd.svg";
export { ForwardRef as ReactComponent };